import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const DUMMY = {
  cases_entered:  "12,480",
  cases_accepted: "11,902",
  cases_rejected: "578",
  accepted_kg:    "238,040 kg",
  rejected_kg:    "11,560 kg",
};

const boxes = [
  { key: "cases_entered",  label: "Case Entered"   },
  { key: "cases_accepted", label: "Case Accepted"  },
  { key: "cases_rejected", label: "Case Rejected"  },
  { key: "accepted_kg",    label: "Accepted KG"    },
  { key: "rejected_kg",    label: "Rejected KG"    },
];

const ReceivingAreaData = ({ data = DUMMY, isLoading = false }) => (
  <DashboardCard title="Receiving Data">
    <div className="fqm-grid">
      {boxes.map((b) => (
        <div key={b.key} className="pp-brokering-box fqm-box">
          <div className="pp-brokering-box-label">{b.label}</div>
          <div className="pp-brokering-box-value">
            {isLoading
              ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
              : (data?.[b.key] ?? "—")
            }
          </div>
        </div>
      ))}
    </div>
  </DashboardCard>
);

export default ReceivingAreaData;
